import { render, staticRenderFns } from "./CreateFormRedPacketRecord.vue?vue&type=template&id=1c85a1e5&scoped=true"
import script from "./CreateFormRedPacketRecord.vue?vue&type=script&lang=js"
export * from "./CreateFormRedPacketRecord.vue?vue&type=script&lang=js"
import style0 from "./CreateFormRedPacketRecord.vue?vue&type=style&index=0&id=1c85a1e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85a1e5",
  null
  
)

export default component.exports